<template>
	<div 
	class="form-group" 
	:class="formGroupClass">
		<form-label 
		v-if="name" 
		:for="id" >
			{{name}}
		</form-label>

		<v-select 
		v-bind="$attrs"
		@search="$emit('search', $event)"
		@input="input" 
		:value="val"
		:class="{
			'is-invalid': $hasErrors(errors)
		}">

			<template #selected-option="option">
				<slot name="selected-option" v-bind="{option}"></slot>
			</template>
			
			<template slot="option" slot-scope="option">
				<slot name="option" v-bind="{option}"></slot>
			</template>

			<template slot="no-options">
				<slot name="no-options">
					{{$t('form.Type to search')}}
				</slot>
		    </template>

		</v-select>

		<form-errors v-bind="{errors}" />
		
	</div>
</template>

<script>

	import { mapState } from 'vuex'

	export default {

		inheritAttrs: false,

		props: {
			id: {
				type: String,
				default() {
					return `input-select-${this._uid}`
				},
			},

			formGroupClass: {
				type: [String, Array],
				default: ''
			},
			
			errors: {
  				type: String,
 				default: "",
  			},

			value: [String, Number, Boolean, Array, Object],
			name: String,
			sublabel: String

		},

		computed: {

			val() {
				return this.value
			}

		},

		methods: {

			input(value) {
				this.$emit('input', value)
			}

		}
	}
</script>
